import { render, staticRenderFns } from "./SingleTask.vue?vue&type=template&id=5e537e06"
import script from "./SingleTask.vue?vue&type=script&lang=js"
export * from "./SingleTask.vue?vue&type=script&lang=js"
import style0 from "./SingleTask.vue?vue&type=style&index=0&id=5e537e06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports